<template>
  <modal
    name="termsAndConditions"
    modal-style="compact"
    :display-header-title="false"
  >
    <terms-and-conditions />
  </modal>
</template>


<script>
  import TermsAndConditions from './terms-and-conditions/index.vue';


  export default {
    name: 'TermsAndConditionalsModal',

    components: {
      TermsAndConditions
    }
  };
</script>
